import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Modifier — crayon duotone */
export const EditIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Pointe du crayon menthe */}
      <path d="M14.5 5.5l4 4-9.5 9.5-4.5.5.5-4.5 9.5-9.5z" fill="var(--equiply-icon-bg)" fillOpacity="0.45" />
      {/* Corps crayon */}
      <path d="M14.5 5.5l4 4-9.5 9.5-4.5.5.5-4.5 9.5-9.5z" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round" />
      {/* Tête (gomme) */}
      <path d="M13 7l4 4" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
      {/* Souligné */}
      <path d="M14 21h7" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
EditIcon.displayName = "EditIcon";
